/* eslint-disable max-len */
/**
 * Awvent - Awvent Subcriptions API
 * Awvent Subscriptions Apis
 *
 * OpenAPI spec version: v1
 * Contact: info@prestine.in
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

 import { Inject, Injectable, Optional }                      from '@angular/core';
 import { HttpClient, HttpHeaders, HttpParams,
          HttpResponse, HttpEvent }                           from '@angular/common/http';
 import { CustomHttpUrlEncodingCodec }                        from '../../../../encoder';

 import { Observable }                                        from 'rxjs';
 import { environment }                                        from '../../../../../environments/environment';

 import { SubscriptionStatus } from '../model/subscriptionStatus';
 import { TenantCreateCommand } from '../model/tenantCreateCommand';
 import { TenantDtoIListWebApiPagedResponse } from '../model/tenantDtoIListWebApiPagedResponse';
 import { TenantDtoWebApiResponse } from '../model/tenantDtoWebApiResponse';
 import { TenantUpdateCommand } from '../model/tenantUpdateCommand';

 import { BASE_PATH, COLLECTION_FORMATS }                     from '../../../../variables';
 import { Configuration }                                     from '../../../../configuration';


 @Injectable()
 export class TenantService {

    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    protected basePath = environment.api.subscriptions;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

     /**
      *
      *
      * @param xTenantId
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantActivatePut(xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoWebApiResponse>;
     public tenantActivatePut(xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoWebApiResponse>>;
     public tenantActivatePut(xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoWebApiResponse>>;
     public tenantActivatePut(xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling tenantActivatePut.');
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<TenantDtoWebApiResponse>('put',`${this.basePath}/Tenant/Activate`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantCancelPut(xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoWebApiResponse>;
     public tenantCancelPut(xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoWebApiResponse>>;
     public tenantCancelPut(xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoWebApiResponse>>;
     public tenantCancelPut(xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling tenantCancelPut.');
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<TenantDtoWebApiResponse>('put',`${this.basePath}/Tenant/Cancel`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantCancelTrailPut(xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoWebApiResponse>;
     public tenantCancelTrailPut(xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoWebApiResponse>>;
     public tenantCancelTrailPut(xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoWebApiResponse>>;
     public tenantCancelTrailPut(xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling tenantCancelTrailPut.');
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<TenantDtoWebApiResponse>('put',`${this.basePath}/Tenant/CancelTrail`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param newPackageId
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantChangePackagePut(xTenantId: string, newPackageId?: string, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoWebApiResponse>;
     public tenantChangePackagePut(xTenantId: string, newPackageId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoWebApiResponse>>;
     public tenantChangePackagePut(xTenantId: string, newPackageId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoWebApiResponse>>;
     public tenantChangePackagePut(xTenantId: string, newPackageId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling tenantChangePackagePut.');
         }


         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (newPackageId !== undefined && newPackageId !== null) {
             queryParameters = queryParameters.set('newPackageId', newPackageId as any);
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<TenantDtoWebApiResponse>('put',`${this.basePath}/Tenant/ChangePackage`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param packageId
      * @param isTrialMode
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantCreateSubscriptionPut(xTenantId: string, packageId?: string, isTrialMode?: boolean, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoWebApiResponse>;
     public tenantCreateSubscriptionPut(xTenantId: string, packageId?: string, isTrialMode?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoWebApiResponse>>;
     public tenantCreateSubscriptionPut(xTenantId: string, packageId?: string, isTrialMode?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoWebApiResponse>>;
     public tenantCreateSubscriptionPut(xTenantId: string, packageId?: string, isTrialMode?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling tenantCreateSubscriptionPut.');
         }

         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (packageId !== undefined && packageId !== null) {
             queryParameters = queryParameters.set('packageId', packageId as any);
         }
         if (isTrialMode !== undefined && isTrialMode !== null) {
             queryParameters = queryParameters.set('isTrialMode', isTrialMode as any);
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<TenantDtoWebApiResponse>('put',`${this.basePath}/Tenant/CreateSubscription`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantDeactivatePut(xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoWebApiResponse>;
     public tenantDeactivatePut(xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoWebApiResponse>>;
     public tenantDeactivatePut(xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoWebApiResponse>>;
     public tenantDeactivatePut(xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling tenantDeactivatePut.');
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<TenantDtoWebApiResponse>('put',`${this.basePath}/Tenant/Deactivate`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param extenstionPeriodInDays
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantExtendTrailPut(xTenantId: string, extenstionPeriodInDays?: number, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoWebApiResponse>;
     public tenantExtendTrailPut(xTenantId: string, extenstionPeriodInDays?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoWebApiResponse>>;
     public tenantExtendTrailPut(xTenantId: string, extenstionPeriodInDays?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoWebApiResponse>>;
     public tenantExtendTrailPut(xTenantId: string, extenstionPeriodInDays?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling tenantExtendTrailPut.');
         }


         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (extenstionPeriodInDays !== undefined && extenstionPeriodInDays !== null) {
             queryParameters = queryParameters.set('extenstionPeriodInDays', extenstionPeriodInDays as any);
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<TenantDtoWebApiResponse>('put',`${this.basePath}/Tenant/ExtendTrail`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param city
      * @param pincode
      * @param district
      * @param state
      * @param country
      * @param packageId
      * @param status
      * @param fromTime
      * @param toTime
      * @param orderBy
      * @param isOrderByDescending
      * @param searchText
      * @param pageNumber
      * @param pageSize
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantGet(city?: string, pincode?: string, district?: string, state?: string, country?: string, packageId?: string, status?: SubscriptionStatus, fromTime?: Date, toTime?: Date, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoIListWebApiPagedResponse>;
     public tenantGet(city?: string, pincode?: string, district?: string, state?: string, country?: string, packageId?: string, status?: SubscriptionStatus, fromTime?: Date, toTime?: Date, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoIListWebApiPagedResponse>>;
     public tenantGet(city?: string, pincode?: string, district?: string, state?: string, country?: string, packageId?: string, status?: SubscriptionStatus, fromTime?: Date, toTime?: Date, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoIListWebApiPagedResponse>>;
     public tenantGet(city?: string, pincode?: string, district?: string, state?: string, country?: string, packageId?: string, status?: SubscriptionStatus, fromTime?: Date, toTime?: Date, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (city !== undefined && city !== null) {
             queryParameters = queryParameters.set('City', city as any);
         }
         if (pincode !== undefined && pincode !== null) {
             queryParameters = queryParameters.set('Pincode', pincode as any);
         }
         if (district !== undefined && district !== null) {
             queryParameters = queryParameters.set('District', district as any);
         }
         if (state !== undefined && state !== null) {
             queryParameters = queryParameters.set('State', state as any);
         }
         if (country !== undefined && country !== null) {
             queryParameters = queryParameters.set('Country', country as any);
         }
         if (packageId !== undefined && packageId !== null) {
             queryParameters = queryParameters.set('PackageId', packageId as any);
         }
         if (status !== undefined && status !== null) {
             queryParameters = queryParameters.set('Status', status as any);
         }
         if (fromTime !== undefined && fromTime !== null) {
             queryParameters = queryParameters.set('FromTime', fromTime.toISOString() as any);
         }
         if (toTime !== undefined && toTime !== null) {
             queryParameters = queryParameters.set('ToTime', toTime.toISOString() as any);
         }
         if (orderBy) {
             orderBy.forEach((element) => {
                 queryParameters = queryParameters.append('OrderBy', element as any);
             });
         }
         if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
             queryParameters = queryParameters.set('IsOrderByDescending', isOrderByDescending as any);
         }
         if (searchText !== undefined && searchText !== null) {
             queryParameters = queryParameters.set('SearchText', searchText as any);
         }
         if (pageNumber !== undefined && pageNumber !== null) {
             queryParameters = queryParameters.set('PageNumber', pageNumber as any);
         }
         if (pageSize !== undefined && pageSize !== null) {
             queryParameters = queryParameters.set('PageSize', pageSize as any);
         }

         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<TenantDtoIListWebApiPagedResponse>('get',`${this.basePath}/Tenant`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param id
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantIdGet(id: string, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoWebApiResponse>;
     public tenantIdGet(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoWebApiResponse>>;
     public tenantIdGet(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoWebApiResponse>>;
     public tenantIdGet(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (id === null || id === undefined) {
             throw new Error('Required parameter id was null or undefined when calling tenantIdGet.');
         }

         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<TenantDtoWebApiResponse>('get',`${this.basePath}/Tenant/${encodeURIComponent(String(id))}`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param body
      * @param xRequestId
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantPost(body?: TenantCreateCommand, xRequestId?: string, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoWebApiResponse>;
     public tenantPost(body?: TenantCreateCommand, xRequestId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoWebApiResponse>>;
     public tenantPost(body?: TenantCreateCommand, xRequestId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoWebApiResponse>>;
     public tenantPost(body?: TenantCreateCommand, xRequestId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



         let headers = this.defaultHeaders;
         if (xRequestId !== undefined && xRequestId !== null) {
             headers = headers.set('x-request-id', String(xRequestId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected !== undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<TenantDtoWebApiResponse>('post',`${this.basePath}/Tenant`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param body
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantPut(body?: TenantUpdateCommand, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoWebApiResponse>;
     public tenantPut(body?: TenantUpdateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoWebApiResponse>>;
     public tenantPut(body?: TenantUpdateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoWebApiResponse>>;
     public tenantPut(body?: TenantUpdateCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected !== undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<TenantDtoWebApiResponse>('put',`${this.basePath}/Tenant`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public tenantRenewPut(xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<TenantDtoWebApiResponse>;
     public tenantRenewPut(xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantDtoWebApiResponse>>;
     public tenantRenewPut(xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantDtoWebApiResponse>>;
     public tenantRenewPut(xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling tenantRenewPut.');
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<TenantDtoWebApiResponse>('put',`${this.basePath}/Tenant/Renew`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      * @param consumes string[] mime-types
      * @return true: consumes contains 'multipart/form-data', false: otherwise
      */
      private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

 }
